import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.056 15.278H6.389a.557.557 0 01-.556-.556v-10c0-.305.25-.555.556-.555h1.667c.305 0 .555.25.555.555v10c0 .306-.25.556-.555.556zm5.555 0h-1.667a.557.557 0 01-.555-.556v-10c0-.305.25-.555.556-.555h1.666c.306 0 .556.25.556.555v10c0 .306-.25.556-.556.556z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
